module.exports = __webpack_public_path__ + "img/智能识别--人脸比对.6b0dfed7.png";